/**
 * @description
 * Common trait used for Nodes which needs image crop handling.
 * ### Usage
 * Extending class's schema requires the following property definitions in its `schema`:
 * ```
 * crops: {type: 'object', default: []}
 * ```
 *
 * @memberof Trait
 * @typedef Trait.imageCropTrait
 * @mixin imageCropTrait
 *
 * @example
 * import {withTraits, traitBundle} from 'writer'
 * import {BlockNode} from 'substance'
 * const {imageCropTrait} = traitBundle
 *
 * class MyImageNode extends withTraits(BlockNode, imageCropTrait) {
 *    // Class MyImageNode will contain all functions from imageCropTrait
 * }
 *
 * MyImageNode.define({
 *    type: 'myimage',
 *    crops: {type: 'object', default: []}
 * })
 *
 * @property {function(object, boolean)} setSoftcropData Sets `crops`-, and `disableAutomaticCrop`-properties on node
 */
const imageCropTrait = (api) => {
    return {
        /**
         * @memberOf Trait.imageCropTrait
         * @param {object}  cropData
         * @param {boolean} disableAutomaticCrop
         */
        setSoftcropData(cropData, disableAutomaticCrop) {
            api.editorSession.transaction((tx) => {
                tx.set([this.id, 'crops'], cropData)
                tx.set([this.id, 'disableAutomaticCrop'], disableAutomaticCrop)
            })
        }
    }
}

export {imageCropTrait}
